module.exports = __webpack_public_path__ + "static/media/Pipeline.ccc37f05.svg";